export interface ForecastCard {
  [date: string]: {
    temp_high: string;
    temp_low: string;
    weather: string;
    timestamp: number;
    timezone_offset: number;
  };
}

export interface WeatherCard {
  name: string;
  country: string;
  weather_id: number;
  weather_condition: string;
  weather_main: string;
  weather_icon: string;
  dt: number;
  temp: string;
  feels_like: string;
  timezone: string;
  highlights: {
    sunrise: number;
    sunset: number;
    uvi: number;
    humidity: number;
    pressure: number;
    wind_speed: number;
    wind_deg: number;
    rain: number;
    snow: number;
    pop: number;
    visibility: number;
  };
}

export interface ForecastObj {
  dt: number;
  date: string;
  temp: number;
  pop: number;
  weather: {
    id: number;
    main: string;
    description: string;
    icon: string;
  };
  rain?: number;
  snow?: number;
  timezone_offset: number;
}

export interface Coordinates {
  lat: number;
  lon: number;
  country?: string;
}
// Generated by https://quicktype.io

export interface JSONMap {
  [code: string]: {
    label: string;
    icon: string;
    image?: string;
  };
}

export enum Units {
  metric = 'metric',
  imperial = 'imperial',
}

export enum compassSector {
  N,
  NNE,
  NE,
  ENE,
  E,
  ESE,
  SE,
  SSE,
  S,
  SSW,
  SW,
  WSW,
  W,
  WNW,
  NW,
  NNW,
}

export type CitiesObj = {
  label: {
    name: string;
    region: string;
    country: string;
    countryCode: string;
  };
  coord: Coordinates;
};
